import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FirPost86TaxHistoryService {
  constructor(private http: HttpClient) {}

  getPost86TaxHistory(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=mxa5sf`;
    const body = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        body.set(key, String(value));
      }
    });
    body.set('process_name', 'GTAPS Get Post 86 E&P History Data');
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }
}
